import type { VectorLayerStyle } from './model';
import { DEFAULT_DATA_COLOURS } from './dataDefaults';

export function createDefaultVectorLayerStyle(): VectorLayerStyle {
  return {
    kind: 'vector',
    classification: { mode: 'single' },
    symbols: {
      point: {
        shape: 'circle',
        fillColor: DEFAULT_DATA_COLOURS.point,
        radius: 6,
        opacity: 1,
        outlineColor: '#ffffff',
        outlineWidth: 1.5,
      },
      line: {
        color: DEFAULT_DATA_COLOURS.line,
        dash: 'solid',
        offset: 0,
        opacity: 0.92,
        width: 3,
      },
      polygon: {
        fillColor: DEFAULT_DATA_COLOURS.polygon,
        fillOpacity: 0.8,
        outlineColor: '#ffffff',
        outlineWidth: 0.75,
      },
    },
  };
}
